package uz.ferro.erp.feature.appuser.ui

import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import mui.icons.material.PersonAdd
import mui.material.*
import mui.material.Size
import mui.system.sx
import react.*
import react.dom.events.ChangeEvent
import react.dom.onChange
import react.router.useOutletContext
import uz.ferro.erp.feature.appuser.data.UserRepository
import uz.ferro.erp.feature.appuser.model.UserDto
import uz.ferro.erp.feature.home.ui.DashboardUI
import uz.ferro.erp.feature.menu.model.MenuItem
import uz.ferro.erp.ui.HorizontalLayout
import uz.ferro.erp.ui.VerticalLayout
import uz.ferro.erp.ui.table.CellItem
import uz.ferro.erp.ui.table.HeaderItem
import uz.ferro.erp.ui.table.RowItem
import uz.ferro.erp.ui.table.TableView
import web.cssom.*
import web.html.HTMLInputElement

val UserListPage = FC {
    val dashboardUI = useOutletContext<DashboardUI>()

    // filter params
    var searchQuery by useState("")

    // data
    var appUsers by useState<List<UserDto>>(emptyList())
    var filteredAppUsers by useState<List<UserDto>>(emptyList())
    var modalOpen by useState(false)
    var editUserId by useState<Long?>(null)

    fun loadData() {
        MainScope().launch {
            try {
                appUsers = UserRepository.getUsers()
            } catch (e: Exception) {
                console.error(e)
            }
        }
    }

    Modal {
        open = modalOpen
        onClose = { _, _ -> modalOpen = false }

        Box {
            sx {
                width = 100.pct
                height = 100.pct
            }
            UserDetailsPage {
                this.modalOpen = this@Modal.open
                this.userId = editUserId
                onCloseModal = { modalOpen = false }
            }
        }
    }

    useEffectOnce {
        dashboardUI.setTitle("Xodimlar")
        dashboardUI.setMenuItems(
            page = "user",
            items = listOf(
                MenuItem(
                    title = "Yangi",
                    icon = PersonAdd,
                    action = {
                        editUserId = null
                        modalOpen = true
                    }
                ),
            )
        )
        loadData()
    }

    useEffect(searchQuery, appUsers) {
        filteredAppUsers = if (searchQuery.isBlank()) {
            appUsers
        } else {
            appUsers.filter { appUser ->
                listOfNotNull(
                    appUser.name,
                    appUser.username,
                    appUser.salesPerson?.name,
                ).any { it.contains(searchQuery, ignoreCase = true) }
            }
        }
    }

    useEffect(editUserId) {
        console.log("Editing userId: $editUserId")
    }

    VerticalLayout {
        space = 16.px
        sx {
            padding = 16.px
            alignItems = AlignItems.stretch
            flexGrow = number(1.0)
        }

        HorizontalLayout {
            space = 16.px

            TextField {
                placeholder = "Qidiruv"
                size = Size.small
                value = searchQuery
                onChange = { event ->
                    event as ChangeEvent<HTMLInputElement>
                    searchQuery = event.target.value
                }
                sx {
                    paddingTop = 4.px
                    paddingBottom = 4.px
                    width = 250.px
                    height = 40.px
                }
            }

        }

        Paper {
            sx {
                position = Position.relative
                width = 100.pct
                flexGrow = number(1.0)
                overflowY = Auto.auto
            }

            TableView {
                headers = listOf(
                    HeaderItem("ID"),
                    HeaderItem("To'liq ismi"),
                    HeaderItem("Login"),
                    HeaderItem("Sotuv menejeri"),
                    HeaderItem("Satuv joyi"),
                    HeaderItem("Sap xodimi"),
                    HeaderItem("Holati"),
                )
                items = filteredAppUsers
                    .mapIndexed { index, appUser ->
                        RowItem(
                            key = index.toString(),
                            cells = listOf(
                                CellItem(
                                    title = appUser.id.toString()
                                ),
                                CellItem(
                                    title = appUser.name
                                ),
                                CellItem(
                                    title = appUser.username
                                ),
                                CellItem(
                                    title = appUser.salesPerson?.name
                                ),
                                CellItem(
                                    title = appUser.salesPoint?.id
                                ),
                                CellItem(
                                    title = appUser.sapEmployeeName
                                ),
                                CellItem(
                                    title = appUser.disabled?.let { if (it) "Noaktiv" else "Aktiv" }
                                )
                            )
                        )
                    }

                enableRowEdit = true
                onEditClick = {index ->
                    editUserId = filteredAppUsers[index.toInt()].id
                    modalOpen = true
                }
            }
        }
    }
}